module.exports = __webpack_public_path__ + "static/media/dhl_logo.1dd6f148.png";